import reducer, { ErrorState } from './reducer';
import * as selectors from './selectors';

export type { ErrorState };

export const errorStore = {
  selectors,
};

export default reducer;
